import * as L from 'leaflet';
import "leaflet-routing-machine";
import * as cors from 'corslite';

export class DPViamichelin {
    private options: any = {
        serviceUrl: 'https://apir.viamichelin.com/apir/1/route.json/eng',
        veht: 0,
        itit: 0,
        timeout: 180 * 1000,
        avoidTolls: false,
    }
    private apiKey: string;

    private initialize = () => {
        L.Util.setOptions(this, this.options);
    }

    getViaMichelinRouting(apiKey: string, options?: any) {
        this.apiKey = apiKey;
        const localOptions = { ...this.options }
        this.options = {
            ...localOptions,
            ...options
        }
        L.Routing['ViaMichelin'] = L.Class.extend({
            options: this.options,
            intialize: this.initialize,
            route: this.route,
            buildRouteUrl: this.buildRouteUrl
        });

        return new L.Routing['ViaMichelin']();
    }

    route = (waypoints: any, callback: any, context: any, options: any) => {
        let timedOut = false,
            wps = [],
            url: string,
            timer: any,
            wp: any
        options = options || {};
        url = this.buildRouteUrl(waypoints);

        timer = setTimeout(function () {
            timedOut = true;
            callback.call(context || callback, {
                status: -1,
                message: 'viaMichelin request timed out.'
            });
        }, this.options.timeout);

        // Create a copy of the waypoints, since they
        // might otherwise be asynchronously modified while
        // the request is being processed.
        for (let i = 0; i < waypoints.length; i++) {
            wp = waypoints[i];
            wps.push({
                latLng: wp.latLng,
                name: wp.name,
                options: wp.options
            });
        }

        cors(url, (err: any, resp: any) => {
            clearTimeout(timer);
            if (!timedOut) {
                if (!err) {
                  const data = resp.responseText;
                    this.routeDone(data, wps, callback, context);
                } else {
                    callback.call(context || callback, {
                        status: -1,
                        message: 'HTTP request failed: ' + err
                    });
                }
            }
        });

        return this;
    }

    buildRouteUrl(steps: any) {
        let locs = [],
            baseUrl: string;

        for (let i = 0; i < steps.length; i++) {
            const coordinates = `1:p:${steps[i].latLng.lng}:${steps[i].latLng.lat}`
            locs.push(coordinates);
        }

        baseUrl = this.options.serviceUrl + '?' + 'steps=' + locs.join(';') + ";";
        return baseUrl + L.Util.getParamString(L['extend']({
            veht: this.options.veht,
            itit: this.options.itit,
            avoidTolls: this.options.avoidTolls,
            authkey: this.apiKey,
            callback: 'route_response'
        }, this.options.urlParameters), baseUrl);

    }

    private routeDone(response: any, inputWaypoints: any, callback: any, context: any) {

        let alts = [],
        instructions = [];

        const parsedResponse = JSON.parse(response.split('route_response(')[1].slice(0,-1));
        
        context = context || callback;
        if (parsedResponse.error) {
            callback.call(context, {
                status: parsedResponse.error.errorCode,
                message: parsedResponse.error.errorMsg
            });
            return;
        }
        const coordinates = this.decodePolyline(parsedResponse.iti.itineraryTrace);
        const { totalDist,totalTime } = parsedResponse.iti.header.summaries[0];
        const totalSummary = {
            totalDistance: totalDist,
            totalTime: totalTime
        };
        const roadSheet = parsedResponse.iti.roadSheet;
        console.log(roadSheet);
        // for (let i = 0; i < roadSheet.length; i++) {
        //     instructions.push({
        //         distance: roadSheet[i].travelDistance * 1000,
        //         time: roadSheet[i].travelDuration,
        //         type: roadSheet.length - 1 ? "DestinationReached" : "WaypointReached",
        //         index: i
        //     })
        // }
        alts = [{
            name: '',
            coordinates: coordinates,
            instructions: instructions,
            summary: totalSummary,
            inputWaypoints: inputWaypoints,
            actualWaypoints: inputWaypoints,
        }];

        callback.call(context, null, alts);
    }
    private decodePolyline(encoded: string) {
       const precision = Math.pow(10, -6);
        let len = encoded.length, index=0, lat=0, lng = 0, array = [];
        while (index < len) {
           let b, shift = 0, result = 0;
           do {
              b = encoded.charCodeAt(index++) - 63;
              result |= (b & 0x1f) << shift;
              shift += 5;
           } while (b >= 0x20);
           let dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
           lng += dlng;
           shift = 0;
           result = 0;
           do {
              b = encoded.charCodeAt(index++) - 63;
              result |= (b & 0x1f) << shift;
              shift += 5;
           } while (b >= 0x20);
           let dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
           lat += dlat;
           array.push(new L.LatLng(lat * precision,lng * precision));
        }
        return array;
    };
}


